module.exports = __webpack_public_path__ + "img/donut-graph.dc3d47f3.svg";